import React from 'react'

import { Prediction } from '@app/graphql/types'
import { bemJoin } from '@app/lib/bem'
import { predictionMap } from '@app/modules/Messages/Components/UtilityBillAICheckResults/CheckResults/helper/predictionMap'
import { CheckResultsTable } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsTable'
import { HighlightedResult } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/HighlightedResult'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'
import { formatNumber } from '@app/modules/Messages/Components/UtilityBillAICheckResults/utils'

import './InvoiceItemsCheckResultsTable.scss'

export type InvoiceItemsCheckResultsTableProps = {
  rows: UtilityBillAnalysisChecks['invoiceItems']['children']
  showAllResults?: boolean
}

export const InvoiceItemsCheckResultsTable = ({
  rows,
  showAllResults = false
}: InvoiceItemsCheckResultsTableProps) => {
  const b = bemJoin('invoice-items-check-results')

  const filteredRows = rows.filter((item) => {
    return (
      item.context.prediction &&
      [Prediction.NotOk, Prediction.Questionable].includes(item.context.prediction)
    )
  })

  if (!showAllResults && filteredRows.length === 0) {
    return null
  }

  return (
    <CheckResultsTable>
      <table className={b('table')}>
        <thead>
          <tr>
            <th>{showAllResults ? 'Abrechnungsposition' : ''}</th>
            <th>{showAllResults ? 'Umlegbarkeit' : ''}</th>
            <th>{showAllResults ? 'Verteiler' : ''}</th>
            <th>Wert</th>
          </tr>
        </thead>
        <tbody>
          {(showAllResults ? rows : filteredRows).map((item) => {
            return (
              <tr key={item.context.item}>
                <td>{item.context.item}</td>
                <td>
                  {item.context.prediction && (
                    <HighlightedResult isOk={item.context.prediction === Prediction.Ok}>
                      {predictionMap[item.context.prediction]}
                    </HighlightedResult>
                  )}
                </td>
                <td>{showAllResults ? item.context.distribution?.key : ''}</td>
                <td>{formatNumber(item.context.amount)} €</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </CheckResultsTable>
  )
}
